// extracted by mini-css-extract-plugin
export default {"tableControls":"TableControls_tableControls__hyeS4","button":"TableControls_button__EyslW"};